import { render, staticRenderFns } from "./ContinuePayment.vue?vue&type=template&id=63bdb1b4&scoped=true"
import script from "./ContinuePayment.vue?vue&type=script&lang=js"
export * from "./ContinuePayment.vue?vue&type=script&lang=js"
import style0 from "./ContinuePayment.vue?vue&type=style&index=0&id=63bdb1b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bdb1b4",
  null
  
)

export default component.exports